export const container = ({ width, slides, translate, transitionDuration }) => ({
    width: width * slides.length,
    display: 'flex',
    transform: `translateX(${translate}px)`,
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s`,
    willChange: 'transform',
    position: 'relative',
});

export const extendStepNavFluidContainer = {
    container: () => ({
        paddingTop: '3rem',
        paddingBottom: '3rem',
        paddingLeft: 0,
        paddingRight: 0,
        tabletLarge: {
            paddingTop: 0,
            paddingBottom: '6.25rem',
            paddingLeft: 0,
        },
        desktopFullHD: {
            marginLeft: 0,
            marginRight: 0,
        },
    }),
};

export const extendButton = {
    button: () => ({
        position: 'relative',

        marginTop: '-180%',
        marginLeft: '85%',
    }),
};

export const poweredByContainer = ({ theme: { colors } }) => ({
    color: '#C0C0C0', // This color is not used anywhere else.
    marginTop: '0.6875rem',
    fontSize: '0.875rem',
    fontWeight: 'bold',
});

export const image = () => ({
    marginLeft: '0.25rem',
});

export const hoverContainer = () => ({
    cursor: 'default',
    display: 'inline-block',
});

export const text = ({ theme: { colors } }) => ({
    color: colors.black,
    fontSize: '0.875rem',
});

export const extendText = {
    text: () => ({ display: 'inline-block', marginRight: '0.75rem', marginBottom: 0 }),
};
